<f-flow [vCellSize]="CELL_SIZE" [hCellSize]="CELL_SIZE" (fLoaded)="onLoaded()" fDraggable>
  <f-background>
    <f-rect-pattern [vSize]="CELL_SIZE" [hSize]="CELL_SIZE"></f-rect-pattern>
  </f-background>
  <f-canvas (fCanvasChange)="onZoom($event)" fZoom>
    @for (group of groups(); track group.id) {
      <div
        class="etape text-step"
        [fGroupId]="group.id"
        [fGroupPosition]="group.position"
        [fGroupSize]="group.size"
        [fInputId]="'input' + group.id"
        [fOutputId]="'output' + group.id"
        [fOutputMultiple]="true"
        [cdkContextMenuTriggerFor]="moduleContextMenu"
        [cdkContextMenuTriggerData]="{ data: group, type: 'étape' }"
        (click)="onEtapeClick(group.id)"
        (onDoubleClick)="onDoubleClick(group.id)"
        appClickDouble
        fNodeOutput
        fOutputConnectableSide="right"
        fInputConnectableSide="left"
        fNodeInput
        fGroup
      >
        <ng-icon name="lucideGrid2x2" />
        <p class="paragraph-small-medium text-components-content-neutral-primary">{{ group.nom }}</p>
        <div
          class="module-group"
          (cdkDropListDropped)="onDrop($event, group)"
          cdkDropList
          cdkDropListOrientation="mixed"
        >
          @for (node of orderedGroups(group.modules); track node.id) {
            <button
              class="module drag-box text-module"
              [class.selected]="node.id === moduleStore.selectedEntityId()"
              [id]="node.id"
              [cdkContextMenuTriggerFor]="moduleContextMenu"
              [cdkContextMenuTriggerData]="{ data: node, type: 'module' }"
              (cdkDragMoved)="onDragMoved($event)"
              (click)="onModuleClick(node.id); $event.stopPropagation()"
              cdkDrag
            >
              <ng-icon name="lucideLayoutDashboard" />
              <span class="paragraph-small-medium text-components-content-neutral-primary">{{ node.nom }}</span>
              <div class="overflow-visible" *cdkDragPreview>
                <div
                  class="module dragging-box"
                  [style]="{
                    position: 'absolute',
                    transform:
                      'translate(' + currentPosition.x + 'px, ' + currentPosition.y + 'px) scale(' + zoom + ')',
                  }"
                >
                  <ng-icon name="lucideLayoutDashboard" />
                  <span class="paragraph-small-medium">{{ node.nom }}</span>
                </div>
              </div>
            </button>
          }
        </div>
      </div>
    }

    @for (connecteur of filteredGroupeConnecteurs(); track $index) {
      <f-connection
        [fReassignDisabled]="true"
        [fOutputId]="'output' + connecteur.idEtapePrecedente"
        [fInputId]="'input' + connecteur.idEtapeSuivante"
        [fConnectionId]="connecteur.idEtapePrecedente + '-' + connecteur.idEtapeSuivante"
        fType="bezier"
        fBehavior="fixed"
      />
    }
  </f-canvas>
</f-flow>

<ng-template #moduleContextMenu let-data="data" let-type="type">
  <app-context-menu [menuItems]="nodeContextMenuItems(type)" [data]="data" />
</ng-template>
